// Construye un query string a partir de un objeto de parámetros, en el orden
// de inserción de las claves (URLs estables/testeables). Omite las claves con
// valor `null`/`undefined` —no las envía— y codifica clave y valor con
// `encodeURIComponent`. Devuelve "" si no queda ningún par, o "?k=v&k2=v2".
//
// Reemplaza la interpolación de query strings a mano en `api/`, que no
// codificaba y mandaba `clave=undefined` cuando el valor faltaba.
export function buildQuery(params = {}) {
    const pairs = Object.entries(params)
        .filter(([, value]) => value !== null && value !== undefined)
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
    return pairs.length ? `?${pairs.join("&")}` : "";
}
